/**
 * 城市设置请求接口
 * @author 王振宇
 * @since 2022-04-18
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_CITY_PAGE_LIST: function GET_CITY_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/city/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_CITY_LIST: function GET_CITY_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/city/getList',
        method: 'get',
        params: data
      });
    },
    GET_CITY_INFO: function GET_CITY_INFO() {
      return request({
        url: '/admin/v1/city/info',
        method: 'get'
      });
    },
    SAVE_CITY: function SAVE_CITY() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/city/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_CITY: function UPDATE_CITY() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/city/update',
        method: 'put',
        data: data
      });
    },
    DELETE_CITY: function DELETE_CITY() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/city/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_CITY: function DELETE_BATCH_CITY() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/admin/v1/city/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});